import { OrganizationApiInterface } from "@syadem/kairos-team-js";
import { User } from "../domain/user";
import { AppRouter } from "../appConfig";

export const LAST_HOME_PAGE_KEY = "lastHomepage";

export class RedirectToLiberalOrTeamService {
  constructor(
    private readonly router: AppRouter,
    private readonly localStorage: Storage,
    private readonly organizationApi: OrganizationApiInterface
  ) {}

  async call({ searchParams, user }: { searchParams: URLSearchParams, user: User }) {
    if (!user.verified) {
      this.router.navigate("/account-verification", { replace: true });
      return;
    }

    const importPath = getEvcImportPath(searchParams, this.localStorage.getItem(LAST_HOME_PAGE_KEY));
    if (importPath) {
      this.router.navigate(withSearch(importPath, searchParams), { replace: true });
      return;
    }

    const lastHomePage = this.localStorage.getItem(LAST_HOME_PAGE_KEY);
    if (lastHomePage && lastHomePage.trim() !== "") {
      this.router.navigate(withSearch(lastHomePage, searchParams), { replace: true });
      return;
    }

    if (user.rpps) {
      const destination = searchParams.get("evc") ? "/liberal/health-records/new" : "/liberal";
      this.router.navigate(withSearch(destination, searchParams), { replace: true });
    } else {
      const organizations = await this.organizationApi.allOrganizations();
      const firstOrgWithTeam = organizations.find((org) => org.teams.length > 0);
      const firstTeam = firstOrgWithTeam ? firstOrgWithTeam.teams[0] : undefined;
      if (firstOrgWithTeam && firstTeam) {
        const teamUrl = `/organizations/${firstOrgWithTeam.id}/teams/${firstTeam.id}`;
        const destination = searchParams.get("evc") ? `${teamUrl}/health-records/new` : teamUrl;
        this.router.navigate(withSearch(destination, searchParams), { replace: true });
      } else {
        this.router.navigate("/liberal/rpps-missing", { replace: true });
      }
    }
  }
}

function withSearch(path: string, searchParams: URLSearchParams): string {
  const search = searchParams.toString();
  return search ? `${path}?${search}` : path;
}

function getEvcImportPath(searchParams: URLSearchParams, lastHomePage: string | null): string | null {
  if (!searchParams.get("evc")) return null;

  if (!lastHomePage) {
    return null;
  }

  if (lastHomePage === "/liberal" || lastHomePage === "/liberal/health-records") {
    return "/liberal/health-records/new";
  }

  if (/^\/organizations\/[^/]+\/teams\/[^/]+\/health-records$/.test(lastHomePage)) {
    return `${lastHomePage}/new`;
  }

  return null;
}
